import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const SUPPLIERSAPBANKTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SupplierSapBankType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.SupplierSapBankType.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const SUPPLIERSAPBANKTYPE_CONFIG = {
  entityName: 'SupplierSapBankType',
  localizationKey: 'Controlling::Entity.SupplierSapBankType',
  fields: SUPPLIERSAPBANKTYPE_FIELDS,
  permission: 'ControllingContract.SupplierSapBankTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
